import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import { Box, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import { useCheckUserPermission } from "../../../../api/hooks/useCheckUserPermission";
import useColors from "../../../../api/hooks/useColors";
import { adminPermissionKeys } from "../../../../api/queryKeys";
import CustomToolTipWithPermission from "../../../../components/CustomToolTipWithPermission";
import ConfirmationDialog from "../../../../components/dialogs/ConfirmationDialog";
import {
  PING_STATUS,
  PLATFORM_USER_ACTIONS,
} from "../../../../utils/constants";
import { getPrettyDateTime, useLocalTime } from "../../../../utils/timestamp";
const EmailPingStatus = ({
  status_details,
  setOpenModal,
  userPermissionDetails,
  setUserToPing,
}) => {
  const { permitted: hasPermissionSendEmail } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.PING_ADMIN_PERMISSIONS
  );
  const { permitted: hasPermissionApproveUser } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.APPROVE_USER_PERMISSIONS
  );
  const colors = useColors();
  const { trackEvent, approveUserPermissions } = useAPI();
  const [openDialogForApproved, setOpenDialogForApproved] = useState(false);
  const queryClient = useQueryClient();
  const showLocalTime = useLocalTime();

  const handleDialogClose = () => {
    setOpenDialogForApproved(false);
  };
  const handleConfirm = () => {
    setOpenDialogForApproved(false);
    trackEvent(
      "user approved permission for" + userPermissionDetails.tool_email
    );
    approveUserPermissions(userPermissionDetails.tool_email).then(() => {
      queryClient.invalidateQueries({ queryKey: adminPermissionKeys.all });
    });
  };
  const approvedPing = () => {
    setOpenDialogForApproved(true);
  };

  switch (status_details.status) {
    case PING_STATUS.APPROVED:
      return (
        <>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Typography variant="caption">Approved on:</Typography>
            <Typography variant="caption" color={colors.text_secondary}>
              {getPrettyDateTime(
                status_details?.approved_time.timestamp_utc,
                showLocalTime
              )}
            </Typography>
          </Box>
          {status_details?.approved_by && (
            <Box display={"flex"} flexDirection={"row"} gap={1}>
              <Typography variant="caption">By:</Typography>
              <Typography variant="caption" color={colors.text_secondary}>
                {status_details?.approved_by}
              </Typography>
            </Box>
          )}
        </>
      );
    case PING_STATUS.PENDING:
      return (
        <>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={2}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (hasPermissionSendEmail) {
                trackEvent("user open ping manager modal");
                setOpenModal(true);
                setUserToPing(userPermissionDetails);
              } else {
                return null;
              }
            }}
          >
            <MailOutlineRoundedIcon sx={{ color: colors.primary_main }} />
            <CustomToolTipWithPermission
              title={null}
              permission={hasPermissionApproveUser}
              placement="top"
            >
              <Typography variant="caption" color={colors.primary_main}>
                Ping Manager
              </Typography>
            </CustomToolTipWithPermission>
          </Box>
        </>
      );
    case PING_STATUS.PING_SENT:
      return (
        <>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Typography variant="caption">Sent on</Typography>
            <Typography variant="caption" color={colors.text_secondary}>
              {getPrettyDateTime(
                status_details?.ping_time.timestamp_utc,
                showLocalTime
              )}
            </Typography>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (hasPermissionApproveUser) {
                  approvedPing();
                } else {
                  return null;
                }
              }}
            >
              <CustomToolTipWithPermission
                title={null}
                permission={hasPermissionApproveUser}
                placement="top"
              >
                <Typography variant="caption" color={colors.primary_main}>
                  Approve Permission
                </Typography>
              </CustomToolTipWithPermission>
            </Box>
            <ConfirmationDialog
              openDialog={openDialogForApproved}
              handleDialogClose={handleDialogClose}
              handleConfirm={handleConfirm}
              dialogTitle="Approval Confirmation"
              dialogContentFirstLine="Are you sure you want to approve this permission?"
              confirmationButtonText="Confirm"
            />
          </Box>
        </>
      );
    default:
      return <Box></Box>;
  }
};

export default EmailPingStatus;
